export default __webpack_public_path__ + "static/understanding-your-credit-score-d835eed5ae4dcefb2960d4a48f305bdc.jpg";